<template>
  <div>
    <wrapper>
      <el-image
        v-if="upload_image"
        :src="upload_image"
        @error="imageFailed"
        :class="{ block: isError }"
      >
        <div slot="error" class="image-slot error-image-slot">
          <i class="el-icon-picture-outline error-image"></i>
        </div>
      </el-image>
      <cropper
        v-else-if="img"
        class="cropper"
        :src="img"
        ref="cropper"
        maxWidth="600"
        maxHeight="600"
        :stencil-props="{
          handlers: {},
          scalable: false
        }"
        @change="onChange"
      />
      <div v-else class="block">
        <div slot="error" class="image-slot error-image-slot">
          <i class="el-icon-picture-outline error-image"></i>
        </div>
      </div>
      <results :coordinates="coordinates" :image="resultImage" />
    </wrapper>
    <div>
      <div class="button-load">
        <span
          class="button el-button mt20 el-button--success el-button--small"
          @click="$refs.file.click()"
        >
          <input type="file" ref="file" @change="loadImage" accept="image/*" />
          Load image
        </span>
      </div>
      <el-button class="ml10" size="small" type="success" @click="upload">
        Upload
      </el-button>
    </div>
  </div>
</template>

<script>
import { Cropper } from 'vue-advanced-cropper'
import Wrapper from '@/global/components/Wrapper'
import Results from '@/global/components/Result'
import 'vue-advanced-cropper/dist/style.css'
import { mapState, mapActions, mapMutations } from 'vuex'

export default {
  props: ['track_id', 'image_url'],
  components: {
    Results,
    Cropper,
    Wrapper
  },
  data() {
    return {
      url: process.env.VUE_APP_STORAGE_URL,
      img: null,
      coordinates: {
        width: 0,
        height: 0,
        left: 0,
        top: 0
      },
      imageUpload: {
        id: null,
        image: null
      },
      canvas: null,
      isError: false,
      resultImage: null
    }
  },
  computed: {
    ...mapState('trackImport', ['upload_image'])
  },
  methods: {
    ...mapActions('trackImport', ['uploadImage']),
    ...mapMutations('trackImport', ['setUploadImage']),
    onChange({ coordinates, canvas }) {
      this.coordinates = coordinates
      this.canvas = canvas
      this.resultImage = canvas.toDataURL()
    },
    loadImage(event) {
      // Reference to the DOM input element
      var input = event.target
      // Ensure that you have a file before attempting to read it
      if (input.files && input.files[0]) {
        // create a new FileReader to read this image and convert to base64 format
        var reader = new FileReader()
        // Define a callback function to run, when FileReader finishes its job
        reader.onload = e => {
          // Note: arrow function used here, so that "this.imageData" refers to the imageData of Vue component
          // Read image as base64 and set to imageData
          this.resizeImageBase64(e.target.result)
          event.target.value = ''
          this.setUploadImage(null)
        }
        // Start the reader job - read file as a data url (base64 format)
        reader.readAsDataURL(input.files[0])
      }
    },
    upload() {
      if (this.canvas) {
        this.imageUpload.id = this.track_id
        this.imageUpload.image = this.canvas.toDataURL('image/jpeg')
        this.img = null
        this.canvas = null
        this.resultImage = null
        this.uploadImage(this.imageUpload)
      } else {
        this.$message({
          type: 'error',
          message: `You need to load image first`
        })
      }
    },
    imageFailed() {
      this.isError = true
    }
  }
}
</script>

<style lang="scss">
.cropper {
  height: 600px;
  max-width: 600px;
}
.block {
  height: 600px;
  width: 600px;
}

.error-image {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  background: #f5f7fa;
  color: #909399;
  text-align: center;
}

.error-image-slot {
  font-size: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  background: #f5f7fa;
  color: #909399;
}

.button input {
  display: none;
}

.button-load {
  display: inline-block;
}
</style>
